export default __webpack_public_path__ + "static/media/save-icon-white.f555eccd.svg";